import React, { useEffect } from 'react';
import { Spin } from 'antd';
import usePanoramaProjects from '../../../hooks/usePanoramaProjects';
import PanoramaManageModal from '../../../components/orthoToolbox/PanoramaManageModal';
import { hasCommandFeature, COMMAND_FEATURE_PERMS } from '../../../utils/permissionControl';

/** 是否可管全景（管理后台 / 指挥台权限） */
export function canManagePanoramaAdmin(shouldShowPage) {
  return !!(
    shouldShowPage?.('全景影像管理')
    || shouldShowPage?.('成品管理')
    || shouldShowPage?.('系统设置')
    || hasCommandFeature(COMMAND_FEATURE_PERMS.PANORAMA_MANAGE)
  );
}

/** @deprecated 全景已并入「叠加图层」；保留函数供兼容 */
export function buildPanoramaManageTab(context) {
  const { shouldShowPage } = context;
  if (!canManagePanoramaAdmin(shouldShowPage)) return null;
  return {
    key: 'panorama_manage',
    label: '全景影像',
    children: <PanoramaAdminPanel />
  };
}

/** 叠加图层内嵌的全景管理面板 */
export function PanoramaAdminPanel() {
  const panorama = usePanoramaProjects({
    canManage: true,
    canView: true
  });

  useEffect(() => {
    panorama.loadProjects({ publishedOnly: false });
  }, []);

  return (
    <div>
      <p style={{ color: '#666', marginBottom: 16 }}>
        创建项目、上传等距柱状全景、配置热点与发布。地图挂点开关与图标在「系统设置 → 地图配置 → 地图设置」；
        指挥台叠加工具箱也可管理，并支持地图选点。
      </p>
      <Spin spinning={panorama.busy}>
        <PanoramaManageModal
          variant="page"
          open
          allowMapPick={false}
          busy={panorama.busy}
          projects={panorama.projects}
          onClose={() => {}}
          onCreateProject={panorama.createProject}
          onPatchProject={panorama.patchProject}
          onLoadBundle={panorama.loadBundle}
          onCreateScene={panorama.createScene}
          onUploadEquirect={panorama.uploadEquirect}
          onPatchScene={panorama.patchScene}
          onDeleteScene={panorama.deleteScene}
          onCreateHotspot={panorama.createHotspot}
          onDeleteHotspot={panorama.deleteHotspot}
          onRefresh={() => panorama.loadProjects({ publishedOnly: false })}
        />
      </Spin>
    </div>
  );
}
